<nav class="navbar navbar-expand-lg" data-bs-theme="dark">
  <div class="container-fluid d-flex w-100">
    <button id="home-button" mat-button class="home-button" routerLink="">Skye App</button>

    <div class="d-flex align-items-center">
      <button mat-icon-button (click)="openMobileProductSearchDialog()">
        <mat-icon>search</mat-icon>
      </button>

      @if (favouriteShoppingListId) {
        <button
          class="mobile-only ms-2"
          mat-icon-button
          [routerLink]="['/stock/shopping-lists', favouriteShoppingListId]">
          <mat-icon>shopping_cart</mat-icon>
        </button>
      }

      @if (isAuthenticated) {
        <button mat-icon-button class="ms-2 user-menu-trigger" [matMenuTriggerFor]="userMenu">
          @if (userPicture) {
            <img [src]="userPicture" alt="avatar" class="user-avatar" referrerpolicy="no-referrer" />
          } @else {
            <mat-icon>account_circle</mat-icon>
          }
        </button>
        <mat-menu #userMenu="matMenu">
          @if (userName) {
            <div class="user-name-label" mat-menu-item disabled>{{ userName }}</div>
          }
          <a mat-menu-item routerLink="/user">
            <mat-icon>person</mat-icon>
            <span>Profile</span>
          </a>
          <a mat-menu-item routerLink="/settings">
            <mat-icon>settings</mat-icon>
            <span>Settings</span>
          </a>
          @if (userPermissions.isAdmin) {
            <a mat-menu-item routerLink="/user/management">
              <mat-icon>group</mat-icon>
              <span>User Management</span>
            </a>
          }
          <button mat-menu-item (click)="signOut()">
            <mat-icon>logout</mat-icon>
            <span>Sign out</span>
          </button>
        </mat-menu>
      }

      <button
        mat-icon-button
        class="navbar-toggler ms-2"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation">
        <mat-icon>menu</mat-icon>
      </button>
    </div>
  </div>

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav collapse collapse-horizontal show menu-options" id="menuOptions">
      @for (item of navItems; track item) {
        <li class="nav-item" [ngClass]="{ 'b-nav-dropdown dropdown': item.children !== undefined }">
          @if (item.children) {
            <a
              mat-button
              class="nav-link dropdown-toggle"
              [matMenuTriggerFor]="menu.childMenu"
              role="button"
              aria-expanded="false"
              [ngClass]="{ active: currentModule === item.module }">
              <span class="pe-1">
                <app-menu-item-display-value [item]="item" />
              </span>
            </a>

            <app-menu-item #menu [items]="item.children" />
          } @else {
            <a
              mat-button
              class="nav-link"
              [ngClass]="{ active: currentModule === item.module }"
              [routerLink]="item.route"
              [queryParams]="item.queryParams">
              <app-menu-item-display-value [item]="item" />
            </a>
          }
        </li>
      }
    </ul>
  </div>
</nav>
